import type { Domain } from '@common/types/domain.type';
import { EDomainStatuses } from '@common/enums';

export function getFullDomainName(domainObj: Domain): string {
    let domainFullName = domainObj.name;

    if (domainObj.sub_url) {
        domainFullName = domainFullName + '/' + domainObj.sub_url + '/';
    }

    return domainFullName;
}

export function getFullDomainNameHandler(domains: Domain[]): string {
    if (!domains?.length) {
        return '';
    }

    const customDomain = domains[1];

    if (customDomain && customDomain.is_ssl && customDomain.status !== EDomainStatuses.Deleted) {
        return getFullDomainName(customDomain);
    }

    return getFullDomainName(domains[0]);
}

export function getDomainHandler(domains: Domain[]): Domain | null {
    if (!domains?.length) {
        return null;
    }

    const customDomain = domains[1];

    if (customDomain && customDomain.is_ssl && customDomain.status !== EDomainStatuses.Deleted) {
        return customDomain;
    }

    return domains[0];
}

export function getFullDomainNameHandlerWithProtocol(domains: Domain[]): string {
    if (!domains?.length) {
        return '';
    }

    return 'https://' + getFullDomainNameHandler(domains);
}
